export default "__VITE_ASSET__CWLRVpK6__"